module.exports = __webpack_public_path__ + "img/app-icon.fa2bc73b.svg";